import { scrollToSection } from "../lib/scroll";
import { ArrowRight } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" className="relative z-10 border-t border-white/10 py-14">
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-6 sm:px-10 md:flex-row md:justify-between">
      <button
        data-testid="footer-logo"
        onClick={() => scrollToSection("home")}
        className="font-display text-sm font-semibold tracking-[0.3em] text-white"
      >
        CLOSER.
      </button>
      <p className="text-center text-[13px] font-light text-white/40">
        Websites built to win business —{" "}
        <a
          data-testid="footer-email-link"
          href="mailto:closercontact1@gmail.com"
          className="text-white/70 underline-offset-4 transition-colors duration-300 hover:text-white hover:underline"
        >
          closercontact1@gmail.com
        </a>
      </p>
      <button
        data-testid="footer-cta-button"
        onClick={() => scrollToSection("contact")}
        className="inline-flex items-center gap-2 rounded-full border border-white/25 px-5 py-2.5 text-[13px] font-medium text-white transition-colors duration-300 hover:bg-white hover:text-black"
      >
        Start a Project <ArrowRight size={14} />
      </button>
    </div>
    <p className="mt-10 text-center text-[11px] font-light tracking-[0.3em] text-white/25 uppercase">
      © {new Date().getFullYear()} CLOSER. All rights reserved.
    </p>
  </footer>
);

export default Footer;
